// Internal Imports
import { API_ENDPOINTS } from "../../constants";
import { get, post, put } from "../../api/index";
import { fetchAppConfig } from "../CommonActions/commonService";
import { signOutUser } from "../AuthActions/authActions";
import { GlobalUtils } from "../../utils";

const { readDataFromLocalStorage } = GlobalUtils;

// Destructuring
const { APIS } = API_ENDPOINTS;

/**
 * fetchDocumentByID func fetches document details by ID.
 * @param {string} docID - Refers to the document id to be fetched // "15".
 */

/**
 * We are not using this method to fetch document anymore.
 * Below method (fetchDocumentByDocNo) is being used that fetches doc using docNo instead og docID
 * You may think that you need to use this method. but most probably you don't
 * So confirm with multiple people before uncommenting this and using it.
 * */

// export const fetchDocumentByID = async docID => {
//   const documentData = await get(
//     `${APIS.GET_DOC_ID}/${docID}?fetch_fields=true`,
//   )
//     .then(res => {
//       if (!res.Document) {
//         return new Error("Invalid response. 'Document' key is necessary");
//       }
//       return res.Document;
//     })
//     .catch(error => {
//       console.error("QuotationServices => fetchDocumentByID", error);
//       throw error;
//     });
//   return documentData;
// };

/**
 * fetchDocumentByDocNo func fetches document details by doc Number.
 * @param {string} docNo - Refers to the document number to be fetched // "Q-0000019".
 */
// This method is being used for fetching doc using docNo instead of docID thru out the app
export const fetchDocumentByDocNo = async (docNo, fetchFields = true) => {
  const documentData = await get(
    `${APIS.DOCUMENTS}/${docNo}?fetch_fields=${fetchFields}`,
  )
    .then(res => {
      if (!res.Document) {
        return new Error("Invalid response. 'Document' key is necessary");
      }
      return res.Document;
    })
    .catch(error => {
      console.error("QuotationServices => fetchDocumentByDocNo", error);
      throw error;
    });
  return documentData;
};

export const getAppConfig = async () => {
  const appConfig = await fetchAppConfig();
  const { DealTableView } =
    appConfig && appConfig.App && appConfig.App.views
      ? appConfig.App.views
      : {};
  const columnData = await get(`${APIS.VIEW_METADATA}/${DealTableView}`)
    .then(res => res)
    .catch(error => {
      signOutUser();
      console.debug("configSuccess response", error);
    });
  return columnData;
};

/**
 * fetchDealTableColumns func fetches dealtable column definitions.
 * @param {string} DealTableViewId - Refers to the page view id // "VIWxlvEP8HgeEAJ".
 */

export const fetchDealTableColumns = async tableView => {
  if (!readDataFromLocalStorage("appView")) {
    return getAppConfig();
  }
  const columnData = await get(`${APIS.VIEW_METADATA}/${tableView}`)
    .then(res => res)
    .catch(error => {
      console.error("QuotationServices => fetchDealTableColumns", error);
      return getAppConfig();
    });
  return columnData;
};

/**
 * fetchDealTableRows func fetches dealtable rows.
 * @param {string} dealTableId - Refers to the dealtable id to be fetched // "15"
 * @param {string} DealTableViewId - Refers to the page view id // "VIWxlvEP8HgeEAJ".
 */
export const fetchDealTableRows = async (tableView, tableId) => {
  const rowData = await get(`${APIS.CHILD_VIEWS}/${tableId}/${tableView}`)
    .then(res => res)
    .catch(error => {
      console.error("QuotationServices => fetchDealTableRows", error);
      throw error;
    });
  return rowData;
};

/**
 * addDealTableInDocument func adds dealtable option in the document.
 * @param {number} documentId - Refers to the document id to be fetched // 15
 * @param {number} priceListId - Refers to the pricelist id // 10
 */
export const addDealTableInDocument = async (documentId, priceListId) => {
  const payload = {
    price_list_id: JSON.parse(`${priceListId}`),
  };
  const rowData = await post(
    `${APIS.DOC_DEALS}/${documentId}/deal-tables/`,
    payload,
  )
    .then(res => res.DealTable)
    .catch(error => {
      console.error("QuotationServices => addDealTableInDocument", error);
      throw error;
    });
  return rowData;
};

/**
 * updatePriceBookInDealTable func updates the pricebook assigned to it.
 * @param {number} dealTableId - Refers to the document id to be fetched // 15
 * @param {number} priceListId - Refers to the pricelist id // 10
 */
export const updatePriceBookInDealTable = async (dealTableId, priceListId) => {
  const payload = {
    price_list_id: JSON.parse(`${priceListId}`),
  };
  const rowData = await put(
    `${APIS.DOC_DEALS}/deal-tables/${dealTableId}`,
    payload,
  )
    .then(res => res.DealTable)
    .catch(error => {
      console.error("QuotationServices => updatePriceBookInDealTable", error);
      throw error;
    });
  return rowData;
};



// WEBPACK FOOTER //
// ./src/actions/QuotationActions/QuotationServices.js